import Image from 'app/Components/Shared/Image/image';
import React, {ReactNode, ReactNodeArray, useEffect} from 'react';
import SelfCareNavBarChoiceBoxModelData from '../../../Models/Content/SelfCareNavBarChoiceBoxModelBlockData';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import { Col } from 'reactstrap';
import './index.scss';
import { connect } from 'react-redux';
import { registerSCAction, unregisterSCAction } from '../SelfCareNavBarBlock/selfCareNavBarSlice';
import Config from '../../../Config';
import gaParams from '../../../utilities/analytics/constants';
import { gaEvent } from '../../../utilities/analytics/tracking';
import { prepareUrl } from '../../../utilities/StringHelpers/StringHelpers';

export default class SelfCareNavBarChoiceBoxModel extends EpiComponent<SelfCareNavBarChoiceBoxModelData> {

  constructor(props) {
    super(props);  
  }

  public render(): null | ReactNode | ReactNodeArray {
    const action = {
      actionName: this.props.data.actionName.value,
      actionIcon: this.props.data.actionIcon.value,
      actionUrl: this.props.data.actionUrl.value,
      actionServices: this.props.data.actionServices.value,
      actionIndex: this.props.data.actionIndex.value
    };

    return (
        <ConnectedOption action={action} context={this.getContext()} iContent={this.props.data}/>
    );
  }
}

function Option({ action, scActions, registerAction, unregisterSCAction, context, iContent }) {
  const registeredAction = (scActions || []).find(sca => sca.name === action.actionName && sca.index === action.actionIndex);
  const registeredActionName = registeredAction && registeredAction.name;

  useEffect(() => {
    if (!registeredActionName) {
      registerAction(action);
    }
    
    return () => {
      if (registeredActionName) {
        unregisterSCAction(action);
      } 
    };
  }, [registeredActionName, action, registerAction, unregisterSCAction]);


  function handleURL(url, context, actionName){
    gaEvent(gaParams.SELF_CARE_CLICK_ON_ACTION_BOX.category, gaParams.SELF_CARE_CLICK_ON_ACTION_BOX.eventType, actionName);
    prepareUrl(url, context);
  }

  const mode = registeredAction && registeredAction.mode;

  if (mode !== 'displayed') return null;
  return (
    <Col className="self-care-navbar-options" onClick={() => handleURL(action.actionUrl, context, action.actionName)}>
      <div className="self-care-image-box">
        <Image alt={action.actionName} src={Config.epiBaseUrl + action.actionIcon.url} />
      </div>
      <div className="self-care-image-title">
        {action.actionName}
      </div>
    </Col>
  );
}

const ConnectedOption = connect((state: any ) => ({
  scActions: state.selfCareNavBarBlock.scActions
}), (dispatch) => ({
  registerAction: (scAction) => dispatch(registerSCAction(scAction)),
  unregisterSCAction: (scAction) => dispatch(unregisterSCAction(scAction))
}))(Option)